import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerCaptainPickerComponent } from './customer-captain-picker.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerCaptainPickerService } from './customer-captain-picker-service';

@NgModule({
  declarations: [CustomerCaptainPickerComponent],
  imports: [
    CommonModule,
    MatRadioModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  exports: [CustomerCaptainPickerComponent],
  providers: [CustomerCaptainPickerService],
  entryComponents: [CustomerCaptainPickerComponent],
})
export class CustomerCaptainPickerModule {}
